if (!customElements.get('collection-filter')) {
    customElements.define('collection-filter', class CollectionFilter extends HTMLElement {
        constructor() {
            super();
            this.selectors = {
                collections: '.js-collection-filter-block',
                nav: '.js-collection-filter-nav',
                navToggle: '.js-collection-filter-nav-toggle',
                filterToggle: '.js-collection-filter-toggle',
                filterLists: '.js-collection-filter-list',
                products: '.js-collection-filter-product',
                sortByToggle: '.js-collection-filter-sort-by-toggle',
                sortByTitle: '.js-collection-filter-sort-by-ttl',
                approveToggle: '.js-collection-filter-approve-toggle',
                approveText: '.js-collection-filter-approve-text',
                addToCart: '[data-add-to-cart]',
                productOption: '.js-product-options',
                productOptionField: '.js-product-option-radio',
                productOptionSelect: '.js-product-options-select',
                closeSidebarToggle: '.js-collection-filter-sidebar-close',
                sidebar: '.js-collection-filter-sidebar',
                sidebarOpen: '.js-collection-filter-mob-toggle',
                collectionsWrap: '.js-collection-filter-products',
                noProducts: '.js-collection-filter-no-products'
            }

            this.collections = this.querySelectorAll(this.selectors.collections);
            this.nav = this.querySelector(this.selectors.nav);
            this.navToggle = this.querySelectorAll(this.selectors.navToggle);
            this.filterToggle = this.querySelectorAll(this.selectors.filterToggle);
            this.filterLists = this.querySelectorAll(this.selectors.filterLists);
            this.products = this.querySelectorAll(this.selectors.products);
            this.sortByToggle = this.querySelectorAll(this.selectors.sortByToggle);
            this.sortByTitle = this.querySelector(this.selectors.sortByTitle);
            this.approveToggle = this.querySelectorAll(this.selectors.approveToggle);
            this.closeSidebarToggle = this.querySelectorAll(this.selectors.closeSidebarToggle);
            this.sidebar = this.querySelector(this.selectors.sidebar);
            this.sidebarOpen = this.querySelector(this.selectors.sidebarOpen);
            this.collectionsWrap = this.querySelector(this.selectors.collectionsWrap);
            this.noProducts = this.querySelector(this.selectors.noProducts);

            this.data = [];
            this.dataCollections = [];
            this.dataFilters = {filter1: [], filter2: [], filter3: [], sort: '', collection: 'all'};
            this.isLoading = false;
            this.initData();
            this.init();
            this.initNav();
            this.initFilter();
            this.initSubscriptionWidget();
            this.checkParameter();
            this.setPosition();

            window.addEventListener('resize', () => {
                this.setPosition();
            });
        }

        setPosition() {
            this.querySelector('.collection-nav').style.top = document.querySelector('#shopify-section-header').clientHeight + 'px';
        }

        checkParameter() {
            const urlParams = new URLSearchParams(window.location.search);
            const sortBy = urlParams.getAll('sort-by');
            const filter3 = urlParams.getAll('category');
            const filter2 = urlParams.getAll('tattoo-need');
            const filter1 = urlParams.getAll('collection');
            const mainCollection = urlParams.getAll('main-collection');
            this.dataFilters = {
                filter1: filter1,
                filter2: filter2,
                filter3: filter3,
                sort: sortBy.length > 0 ? sortBy[0] : '',
                collection: mainCollection.length > 0 ? mainCollection[0] : 'all'
            };
            if (this.dataFilters.sort != '') {
                const el = this.querySelector(`${this.selectors.sortByToggle}[data-value="${this.dataFilters.sort}"]`);
                if (el != null) {
                    this.sortEvent(el, false);
                }
            }
            if (this.dataFilters.collection != 'all') {
                const el = this.querySelector(`${this.selectors.navToggle}[data-collection="${this.dataFilters.collection}"]`);
                if (el != null) {
                    this.navEvent(el, true)
                }
            }
            if (this.dataFilters.filter1.length > 0) {
                this.dataFilters.filter1.forEach(item => {
                    const el = this.querySelector(`${this.selectors.filterToggle}[data-filter="${item}"]`);
                    if (el != null) {
                        el.classList.add('is-selected');
                    }
                })
            }
            if (this.dataFilters.filter2.length > 0) {
                this.dataFilters.filter2.forEach(item => {
                    const el = this.querySelector(`${this.selectors.filterToggle}[data-filter="${item}"]`);
                    if (el != null) {
                        el.classList.add('is-selected');
                    }
                })
            }
            if (this.dataFilters.filter3.length > 0) {
                this.dataFilters.filter3.forEach(item => {
                    const el = this.querySelector(`${this.selectors.filterToggle}[data-filter="${item}"]`);
                    if (el != null) {
                        el.classList.add('is-selected');
                    }
                })
            }
            this.filterProducts(false);
        }

        init() {
            this.sidebarOpen.addEventListener('click', (e) => {
                e.preventDefault();
                this.sidebar.classList.toggle('is-show');
            });
            this.closeSidebarToggle.forEach(el => {
                el.addEventListener('click', (e) => {
                    e.preventDefault();
                    this.sidebar.classList.remove('is-show');
                });
            });
            this.approveToggle.forEach(el => {
                el.addEventListener('click', (e) => {
                    e.preventDefault();
                    let showApproveText = false;
                    const parent = el.closest(this.selectors.products);
                    const approveText = parent.querySelector(this.selectors.approveText);
                    const addToCart = parent.querySelector(this.selectors.addToCart);
                    parent.querySelectorAll(this.selectors.productOption).forEach(el => {
                        if (el.querySelectorAll(`${this.selectors.productOptionField}:checked`).length == 0) {
                            showApproveText = true;
                        }
                    });
                    if (showApproveText) {
                        approveText.classList.add('is-show');
                        addToCart.setAttribute('data-variant-not-approve', true);
                    } else {
                        approveText.classList.remove('is-show');
                        addToCart.removeAttribute('data-variant-not-approve');
                    }
                })
            })
            this.querySelectorAll(this.selectors.productOptionField).forEach((el) => {
                el.addEventListener('change', () => {
                    const parent = el.closest(this.selectors.productOption);
                    const select = parent.querySelector(this.selectors.productOptionSelect);
                    select.value = el.value;
                    let changeEvent = new Event('change');
                    select.dispatchEvent(changeEvent);
                    let showApproveText = false;
                    const product = el.closest(this.selectors.products);
                    const approveText = product.querySelector(this.selectors.approveText);
                    const addToCart = product.querySelector(this.selectors.addToCart);
                    product.querySelectorAll(this.selectors.productOption).forEach(el => {
                        if (el.querySelectorAll(`${this.selectors.productOptionField}:checked`).length == 0) {
                            showApproveText = true;
                        }
                    });
                    if (showApproveText) {
                        approveText.classList.add('is-show');
                        addToCart.setAttribute('data-variant-not-approve', true);
                    } else {
                        approveText.classList.remove('is-show');
                        addToCart.removeAttribute('data-variant-not-approve');
                    }
                })
            })
        }

        setUrl() {
            let url = '?';
            let paramName = 'category=';
            if (this.dataFilters.filter3.length > 0) {
                url += (url == '?') ? '' : '&';
                url += paramName + this.dataFilters.filter3.join('&' + paramName);
            }
            paramName = 'tattoo-need=';
            if (this.dataFilters.filter2.length > 0) {
                url += (url == '?') ? '' : '&';
                url += paramName + this.dataFilters.filter2.join('&' + paramName);
            }
            paramName = 'collection=';
            if (this.dataFilters.filter1.length > 0) {
                url += (url == '?') ? '' : '&';
                url += paramName + this.dataFilters.filter1.join('&' + paramName);
            }
            if (this.dataFilters.sort != '') {
                url += `${(url == '?') ? '' : '&'}sort-by=${this.dataFilters.sort}`;
            }
            if (this.dataFilters.collection !== 'all') {
                url += `${(url == '?') ? '' : '&'}main-collection=${this.dataFilters.collection}`;
            }
            if (history.pushState) {
                var newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + url;
                window.history.pushState({path: newurl}, '', newurl);
            }
        }

        initData() {
            this.products.forEach((el) => {
                this.data.push({
                    productId: el.getAttribute('data-product'),
                    filter1: el.getAttribute('data-filter1').split('|'),
                    filter2: el.getAttribute('data-filter2').split('|'),
                    filter3: el.getAttribute('data-filter3').split('|'),
                    element: el,
                })
            });
            this.collections.forEach((collection) => {
                let data = [];
                collection.querySelectorAll(this.selectors.products).forEach((el) => {
                    data.push({
                        element: el,
                        rate: parseFloat(el.getAttribute('data-rating')),
                        created: Number(new Date(el.getAttribute('data-created'))),
                        price: parseInt(el.getAttribute('data-price'), 10)
                    })
                });
                this.dataCollections.push({
                    collection: collection,
                    products: data
                })
            });
        }

        sortProducts(sortValue) {
            this.dataCollections.forEach((colEl) => {
                let newProducts = [...colEl.products];
                switch (sortValue) {
                    case 'top-rated':
                        newProducts.sort((a, b) => (b.rate > a.rate ? 1 : -1));
                        break;
                    case 'created-descending':
                        newProducts.sort((a, b) => (b.created > a.created ? 1 : -1));
                        break;
                    case 'price-ascending':
                        newProducts.sort((a, b) => (a.price > b.price ? 1 : -1));
                        break;
                    case 'price-descending':
                        newProducts.sort((a, b) => (b.price > a.price ? 1 : -1));
                        break;
                    default:
                }
                let index = 0;
                newProducts.forEach((product,) => {
                    if (!product.element.classList.contains('is-hide')) {
                        product.element.style.order = `${(index > 4) ? (index + 1) : index}`;
                        index += 1;
                    }
                });
            })

        }

        toggleNoResult() {
            let hasProducts = false;
            this.collections.forEach(el => {
                if (el.classList.contains('is-active')) {
                   if (el.querySelectorAll(`${this.selectors.products}:not(.is-hide)`).length > 0) {
                        hasProducts = true;
                    }
                }
            });
            if (hasProducts) {
                this.noProducts.classList.remove('is-show')
            } else {
                this.noProducts.classList.add('is-show')
            }
        }

        navEvent(el, isSetUrl) {
            const dataCollection = el.getAttribute('data-collection');
            if (dataCollection !== 'all') {
                this.collections.forEach(collection => {
                    if (collection.getAttribute('data-collection') == dataCollection) {
                        collection.classList.add('is-active');
                    } else {
                        collection.classList.remove('is-active');
                    }
                })
            } else {
                this.collections.forEach(collection => {
                    collection.classList.add('is-active');
                })
            }
            this.navToggle.forEach(elToggle => {
                elToggle.classList.remove('is-active')
            });
            el.classList.add('is-active');
            const yOffset = document.querySelector('#shopify-section-header').clientHeight;
            const y = this.getBoundingClientRect().top + window.scrollY - yOffset;

            window.scrollTo({top: y, behavior: 'smooth'});
            this.dataFilters.collection = dataCollection;
            if (isSetUrl) {
                this.setUrl();
            }
            this.toggleNoResult();
        }

        initNav() {
            this.checkNavPositon();
            document.addEventListener('scroll', () => {
                this.checkNavPositon()
            });
            this.navToggle.forEach(el => {
                el.addEventListener('click', (e) => {
                    e.preventDefault();
                    this.navEvent(el, true)
                });
            });
            document.querySelector('body').addEventListener('click', (e) => {
                if (e.target.closest('.collection-nav__sort-by') == null) {
                    this.sortByTitle.classList.remove('is-open')
                }
            });
            this.sortByTitle.addEventListener('click', (e) => {
                e.preventDefault();
                e.stopPropagation();
                this.sortByTitle.classList.toggle('is-open')
            });

            this.sortByToggle.forEach(el => {
                el.addEventListener('click', (e) => {
                    e.preventDefault();
                    if (!el.classList.contains('is-active')) {
                        this.sortEvent(el, true);
                    }
                });
            });

        }

        sortEvent(el, isSetUrl) {
            this.querySelector(`${this.selectors.sortByToggle}.is-active`).classList.remove('is-active');
            el.classList.add('is-active');
            const sortValue = el.getAttribute('data-value');
            this.sortProducts(sortValue);
            this.sortByTitle.classList.remove('is-open')
            this.dataFilters.sort = sortValue;
            if (isSetUrl == true) {
                this.setUrl();
            }
        }

        initFilter() {
            this.filterToggle.forEach(el => {
                el.addEventListener('click', (e) => {
                    e.preventDefault();
                    if (!this.isLoading) {
                        el.classList.toggle('is-selected');
                        this.filterProducts(true);
                    }
                });
            });
        }

        getValue(arr1, arr2) {
            const arr2Set = new Set(arr2);
            return arr1.some(el => arr2Set.has(el));
        }

        filterProducts(isSetUrl) {
            let tagsUrl = '';
            const activeTags = this.querySelectorAll('.js-collection-filter-toggle.is-selected');

            this.products.forEach((el) => {
                el.classList.add('is-hide');
                el.classList.add('is-fade');
            });
            let dataFilters = {filter1: [], filter2: [], filter3: []};

            this.filterLists.forEach((el) => {
                const activeFilters = el.querySelectorAll('.js-collection-filter-toggle.is-selected');
                let values = []
                let index = 0;
                if (activeFilters.length > 0) {
                    activeFilters.forEach(filter => {
                        values.push(filter.getAttribute('data-filter'));
                        index = filter.getAttribute('data-index');
                    });
                }

                const name = `filter${index}`;
                dataFilters[name] = values;
            })

            let filteredData = this.data;
            if (dataFilters.filter3.length > 0) {
                filteredData = filteredData.filter(el => this.getValue(dataFilters.filter3, el.filter3));
            }
            if (dataFilters.filter2.length > 0) {
                filteredData = filteredData.filter(el => this.getValue(dataFilters.filter2, el.filter2));
            }
            if (dataFilters.filter1.length > 0) {
                filteredData = filteredData.filter(el => this.getValue(dataFilters.filter1, el.filter1));
            }
            filteredData.forEach(el => {
                el.element.classList.remove('is-hide');
                setTimeout(() => {
                    el.element.classList.remove('is-fade');
                }, 1);
            });
            this.collections.forEach(el => {
                if (el.querySelectorAll(`${this.selectors.products}:not(.is-hide)`).length > 0) {
                    el.classList.add('has-products');
                } else {
                    el.classList.remove('has-products')
                }
            });
            const sortValue = this.querySelector(`${this.selectors.sortByToggle}.is-active`).getAttribute('data-value');
            this.sortProducts(sortValue);
            this.dataFilters.filter1 = dataFilters.filter1;
            this.dataFilters.filter2 = dataFilters.filter2;
            this.dataFilters.filter3 = dataFilters.filter3;
            if (isSetUrl == true) {
                this.setUrl();
            } else {
                this.collectionsWrap.classList.add('is-show')
            }
            this.toggleNoResult();
        }

        checkNavPositon() {
            if (this.nav.getBoundingClientRect().top == 136) {
                this.nav.classList.add('is-sticky')
            } else {
                this.nav.classList.remove('is-sticky')
            }
        }

        setSellingPlan(productId, rtxWidgetInjectionParent, addToCart, el) {
            const productData = JSON.parse(document.getElementById(rtxWidgetInjectionParent.getAttribute('data-product-json')).innerHTML);
            const form = rtxWidgetInjectionParent.closest('form');
            const currentVariant = parseInt(form.querySelector("[name='id']").value, 10);
            const variant = productData.variants.find(o => o.id === currentVariant);
            var selectedOption = rtxWidgetInjectionParent.querySelector(`input[name="selling_plan_select"]:checked`);

            if (selectedOption.value === 'onetime') {

                rtxWidgetInjectionParent.querySelector(`#selling_plan_${productId}`).value = '';

                rtxWidgetInjectionParent.querySelectorAll(`.rtx_option_plans`).forEach(plans => {
                    plans.style.display = "none"
                })
                addToCart?.classList.add('is-otp-atc');
                addToCart?.classList.remove('is-sub-atc');
            } else if (selectedOption.value === 'subsave') {
                addToCart?.classList.remove('is-otp-atc');
                addToCart?.classList.add('is-sub-atc');
                if (variant.avaliable) {
                    var planId = form.querySelector('.rtx_option_plans_label.active');
                    if (planId.length > 0) {
                        var id = parseInt(planId.attr('data-id'), 10)
                        const curSelPlan = variant.selling_plan_allocations.find(o => o.selling_plan_id === id)

                        if (curSelPlan) {
                            document.querySelector(`#rtx_widget_injection_parent_${productId} .rtx_option--sub .rtx_option_subheading`).textContent = theme.Currency.formatMoney(curSelPlan.price, theme.moneyFormat)
                        }
                    }
                }
                if (rtxWidgetInjectionParent.querySelector(`input[name="rtx_option_plans_dropdown"]:checked`) == null) {
                    return false;
                }
                rtxWidgetInjectionParent.querySelector(`[name="selling_plan"]`).value = rtxWidgetInjectionParent.querySelector(`input[name="rtx_option_plans_dropdown"]:checked`).value
                rtxWidgetInjectionParent.querySelectorAll(`.rtx_option_plans`).forEach(plans => {
                    plans.style.display = "grid"
                })
            }
        }

        initSubscriptionWidget() {
            this.products.forEach(el => {
                const rtxWidgetInjectionParent = el.querySelector('.rtx_widget_injection_parent');
                if (rtxWidgetInjectionParent != null) {
                    const oneTimeOnePrice = rtxWidgetInjectionParent.getAttribute('data-one-time-one-price');
                    const subOnePrice = rtxWidgetInjectionParent.getAttribute('data-sub-one-price');
                    const oneTimeThreePrice = rtxWidgetInjectionParent.getAttribute('data-one-time-three-price');
                    const subThreePrice = rtxWidgetInjectionParent.getAttribute('data-sub-three-price');

                    const addToCartBtn = el.querySelector(".product-form__cart-submit");
                    addToCartBtn?.classList.add('is-otp-atc');

                    el.querySelectorAll(".variant__size-position").forEach((selector) => {
                        selector.addEventListener('click', function (e) {
                            if (e.target.value === '1') {
                                // if (currentURL.searchParams.get('select') !== 'subscription') {
                                el.getElementsByClassName("rtx_option_subheading one-time")[0].innerText = oneTimeOnePrice
                                // }
                                el.getElementsByClassName("rtx_option_subheading subscription")[0].innerText = subOnePrice
                            } else if (e.target.value === "3") {
                                // if (currentURL.searchParams.get('select') !== 'subscription') {
                                el.getElementsByClassName("rtx_option_subheading one-time")[0].innerText = oneTimeThreePrice
                                // }
                                el.getElementsByClassName("rtx_option_subheading subscription")[0].innerText = subThreePrice

                            }
                        })
                    });


                    let defaultFrequency = 0;
                    const currentProductId = rtxWidgetInjectionParent.getAttribute('data-product-id');
                    const regularProductPrice = rtxWidgetInjectionParent.getAttribute('data-regular-product-price');
                    const sellingPrice = rtxWidgetInjectionParent.getAttribute('data-selling-price');
                    let setBestSelling = false;
                    switch (currentProductId) {
                        case '1803809914978':
                        case '6539606458466':
                        case '6568885846114':
                        case '6541825605730':
                        case '6568886108258':
                        case '4537396068450':
                        case '6622430429282':
                        case '6663258603618':
                            defaultFrequency = 1;
                            setBestSelling = true;
                            break;
                        case '6537580675170':
                        case '6568886009954':
                        case '6694418382946':
                        case '6709339226210':
                            defaultFrequency = 0;
                            setBestSelling = true;
                            break;
                    }


                    rtxWidgetInjectionParent.querySelectorAll(`.rtx_option_plans_label`)[defaultFrequency].classList.add('active');

                    if (setBestSelling) {
                        rtxWidgetInjectionParent.querySelectorAll(`.rtx_option_plans_label`)[0].classList.add('best-seller');
                    }


                    var inputs = el.querySelectorAll(`input[name="selling_plan_select"]`).forEach(rbi => {
                        rbi.addEventListener('change', (e) => {
                            var selected = el.querySelector(`input[name="selling_plan_select"]:checked`)
                            el.querySelectorAll(`.rtx_option`).forEach(option => {
                                option.classList.remove(`option--active`)
                            })
                            selected.closest(`.rtx_option`).classList.add(`option--active`)
                            if (selected.value === 'subsave') {
                                el.querySelector(`[name="selling_plan"]`).value = el.querySelectorAll(`.rtx_option_plans_label`)[defaultFrequency].dataset.id
                                this.setSellingPlan(currentProductId, rtxWidgetInjectionParent, addToCartBtn, el)

                            }
                            if (selected.value === 'onetime') {
                                el.querySelectorAll(`.rtx_option_plans`).forEach(plans => {
                                    plans.style.display = "none"
                                })
                            } else {
                                el.querySelectorAll(`.rtx_option_plans`).forEach(plans => {
                                    plans.style.display = "grid"
                                });
                            }
                            this.setSellingPlan(currentProductId, rtxWidgetInjectionParent, addToCartBtn, el)
                        })
                    });
                    el.querySelectorAll('input[name="rtx_option_plans_dropdown"]').forEach(option => {
                        option.addEventListener('change', () => {
                            el.querySelectorAll(".rtx_option_plans_label").forEach((plan) => {
                                plan.classList.remove('active');
                            })
                            option.parentNode.classList.add('active');
                            this.setSellingPlan(currentProductId, rtxWidgetInjectionParent, addToCartBtn, el);
                        });
                    });

                    addToCartBtn.addEventListener('click', () => {
                        if (addToCartBtn.classList.contains('sold-out')) {
                            return false;
                        }
                    });


                }
            });

        }
    })
}